<div class="ziro-admin-page-content">
  @if (isLoading) {
    <ziro-loading-block></ziro-loading-block>
  }

  @if (!isLoading && !pageDisabled) {
    <div class="col-md-10 offset-md-1 pb-2">
      <ziro-breadcrumbs>
        <ziro-breadcrumb-card-item>
          <div [innerHTML]="'tkey;admin.webex_authentication.about_card' | escapeHtml"></div>
        </ziro-breadcrumb-card-item>
      </ziro-breadcrumbs>
      <ziro-webex-authentication-form
        #authForm
        [entity]="callingSettings"
        [clientIdExists]="clientIdExists"
        [callingSettings]="callingSettings"
      ></ziro-webex-authentication-form>
    </div>
  }

  @if (pageDisabled) {
    <div class="offset-md-1 col-md-10 ziro-page-alert alert border-warning" data-automation="ziro-page-disabled-alert">
      <i class="{{ ziroIcons.WARNING_TRIANGLE }} text-warning fa-4x"></i>
      <div class="ms-3" [innerHTML]="pageDisabledMessage | escapeHtml"></div>
    </div>
  }
</div>

@if (!pageDisabled) {
  <ziro-bottom-nav></ziro-bottom-nav>
}
